<template>
  <section>
    <fullscreen class="full" ref="fullscreen" @change="fullscreenChange">
      <main role="main">
        <div class="row">
          <div class="view-wrap">
            <model-viewer
            background-color="#333" exposure=1
            background-image='/static/images/screen.hdr' class="view-wrap"
            @load="dataOnLoad" autoplay camera-controls :src="src"></model-viewer>
          </div>
          <div v-show="loading" class="loading-box">
            <div class="loading-wrap">
              <div :style="{width: loadWidth+'px'}" class="loading-in"></div>
            </div>
          </div>
        </div>
      </main>
    <a v-show="!loading" :title="fullscreen?'退出全屏':'全屏'" name="fullScreen" @click="toggle" class="full-btn"></a>
    </fullscreen>
  </section>
</template>
<script>
import '@google/model-viewer'
import fullscreen from 'vue-fullscreen'
import Vue from 'vue'
Vue.use(fullscreen)
let interval = {}
export default {
  name: 'app',
  components: {
    // ModelViewer
  },
  data () {
    return {
      src: '',
      fullscreen: false,
      loading: true,
      loadWidth: 0
    }
  },
  mounted () {
    this.src = this.getUrlKey('url') + '.gltf'
  },
  created () {
    this.loadWidth = 0
    interval = setInterval(() => {
      this.loadWidth += 50 * Math.random().toFixed(2)
      if (this.loadWidth >= 250) {
        clearInterval(interval)
      }
    }, 100)
  },
  methods: {
    dataOnLoad () {
      this.loadWidth = 300
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    getUrlKey (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || null
    },
    toggle () {
      this.$refs['fullscreen'].toggle() // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange (fullscreen) {
      console.log(this)
      this.fullscreen = fullscreen
    }
  }
}
</script>
<style lang="css">
section,main,.row,.full{
  width: 100%!important;
  height: 100%!important;
}
.view-wrap{
  width: 100%!important;
  height: 100%!important
}
.section{
  position: relative;
}
.full-btn{
  color: #fff;
  width: 22px;
  height: 22px;
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: url(./../svg/fullScreen.svg) no-repeat left center;
  background-size: 22px 22px;
  cursor: pointer;
}
.full-btn:hover{
  background-image: url(./../svg/fullScreenActive.svg);
}
.loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
}
.loading::before {
    content: '';
    border-radius: 100%;
    margin: 2px;
    border: 3px solid #20a0ff;
    border-bottom-color: transparent;
    height: 36px;
    width: 36px;
    display: inline-block;
    animation: loading-rotate .75s 0s linear infinite;
    vertical-align: middle;
}

.loading::after {
    content: '';
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
}
.loading-box{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #0E0E0E;
  opacity: .5;
}
.loading-wrap{
  width: 300px;
  height: 5px;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 150px);
  background: #777;
  border-radius: 5px;
  overflow: hidden;
}
.loading-in{
  max-width: 300px;
  height: 5px;
  background: #fff;
  z-index: 99;
}
@keyframes loading-rotate{
    0% {
        transform: rotate(0) scale(1);
    }
    50% {
        transform: rotate(180deg) scale(.6);
    }
    100% {
        transform: rotate(360deg) scale(1);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue